import { http } from './http';
import { apiHelper } from 'shared';

const controllerName = 'reader-requests';

class ReaderRequests {
  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}/${queryString}`);
  }

  create(readerRequest) {
    return http.post(`/${controllerName}`, readerRequest);
  }

  process(readerRequestId) {
    return http.put(`/${controllerName}/${readerRequestId}/response`, {});
  }
}

export const readerRequests = new ReaderRequests();
